import { Http } from '../axios/interceptors'

export const allReferralsByCompany = async (param) => Http('GET', `/Referrals/GetByCompany?`, param)

export const getReferral = async id => Http('GET', `/Referrals/Get?idReferred=${id}`)

export const createOrEditReferral = async (body, id = null) => (id ? Http('PUT', `/Referrals/Update`, null, body) : Http('POST', '/Referrals/Create', null, body))

export const deleteReferral = async guid => Http('DELETE', `/Referrals/Delete?idReferred=${guid}&active=false`)
